module.exports = __webpack_public_path__ + "assets/youtube.c9f15792.svg";